import * as React from 'react'
import ReactDOM from 'react-dom';

import useModalAccessibility from '../../../../../Shared/hooks/useModalAccessibility';

interface MultipleDiagnosticsModalProps {
  handleCloseModal: () => void
}

const MultipleDiagnosticsModal = ({ handleCloseModal, }: MultipleDiagnosticsModalProps) => {
  const { modalRef } = useModalAccessibility(handleCloseModal);

  {/* Rendered via portal to document.body so that position:fixed and z-index work correctly.
      The activity library header is a sticky, stacking-context parent, which would otherwise
      trap the fixed backdrop and let selected activity rows show through the overlay. */}
  return ReactDOM.createPortal(
    <div className="modal-container multiple-diagnostics-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="multipleDiagnosticsModalTitle"
        aria-modal="true"
        className="multiple-diagnostics-modal quill-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="multiple-diagnostics-modal-header">
          <h3 className="title" id="multipleDiagnosticsModalTitle">Only one diagnostic can be selected per activity pack</h3>
        </div>

        <div className="multiple-diagnostics-modal-body modal-body">
          <p>Please select only one diagnostic for this activity pack and assign other diagnostics in other activity packs, respectively.</p>
        </div>

        <div className="multiple-diagnostics-modal-footer">
          <div className="buttons">
            <button className="quill-button contained medium green focus-on-light" onClick={handleCloseModal} type="button">Close</button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  )
}

export default MultipleDiagnosticsModal
